import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * OAuth Callback page - handles the redirect from Google OAuth
 * Extracts token and user data from URL and logs the user in
 */
const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { updateUser } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get('token');
      const userDataString = searchParams.get('user');
      const error = searchParams.get('error');

      if (error) {
        // OAuth authentication failed
        console.error('OAuth error:', error);
        navigate('/login?error=' + error);
        return;
      }

      if (!token || !userDataString) {
        console.error('Missing token or user data');
        navigate('/login?error=missing_data');
        return;
      }

      try {
        // Decode user data
        const userData = JSON.parse(decodeURIComponent(userDataString));

        // Store token in localStorage
        localStorage.setItem('token', token);

        // Update auth context with user data
        updateUser(userData);

        // Check if user needs to complete their address
        // OAuth users may not have address information
        const needsAddress = !userData.city || !userData.country || !userData.postal_code || !userData.street_address;

        if (needsAddress) {
          // Redirect to complete profile page
          navigate('/complete-profile');
        } else {
          // Redirect to map
          navigate('/map');
        }
      } catch (error) {
        console.error('Failed to process OAuth callback:', error);
        navigate('/login?error=processing_failed');
      }
    };

    handleCallback();
  }, [searchParams, navigate, updateUser]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: 'var(--bg-primary)',
    }}>
      <div className="spinner"></div>
      <p style={{ marginTop: '20px', color: 'var(--text-secondary)' }}>
        Connexion en cours...
      </p>
    </div>
  );
};

export default OAuthCallback;
